"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m2-10H7v2h7zm0-3H7v2h7zm-7 8h3v-2H7zm12-2v2h-2v2h-2v-2h-2v-2h2v-2h2v2z"
}), 'PlaylistAddCircleOutlined');